var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DrawerComponent from '@src/components/Atoms/Drawer/Drawer';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import InputFormik from '@src/components/Atoms/Formik/Input/InputFormik';
import { toast } from 'react-toastify';
import { handleFocus } from '@src/app/helper/NumberHelpers';
import { useBuktiUpload } from '@src/app/pages/JobPage/JobHooks/JobDetail.hooks';
import { useState } from 'react';
var InsightSchema = Yup.object().shape({});
var Insight = function (_a) {
    var datas = _a.datas, isOpen = _a.isOpen, handleClose = _a.handleClose;
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var insight = datas === null || datas === void 0 ? void 0 : datas.schedules[0].schedule;
    var insightValues = {
        views: (insight === null || insight === void 0 ? void 0 : insight.views) || '',
        likes: (insight === null || insight === void 0 ? void 0 : insight.likes) || '',
        share: (insight === null || insight === void 0 ? void 0 : insight.share) || '',
        comment: (insight === null || insight === void 0 ? void 0 : insight.comment) || '',
        impression: (insight === null || insight === void 0 ? void 0 : insight.impression) || '',
        reach: (insight === null || insight === void 0 ? void 0 : insight.reach) || '',
    };
    var insightBuktiUpload = useBuktiUpload(insight === null || insight === void 0 ? void 0 : insight.pubId).insightBuktiUpload;
    var InsightFormik = useFormik({
        initialValues: insightValues,
        enableReinitialize: true,
        validationSchema: InsightSchema,
        onSubmit: function (values) { return __awaiter(void 0, void 0, void 0, function () {
            var formValues, views, likes, share, comment, impression, reach, finalViews, finalLikes, finalShare, finalComment, finalImpression, finalReach, formData, e_1, error;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        formValues = __assign({ id: insight === null || insight === void 0 ? void 0 : insight.pubId }, values);
                        views = formValues.views, likes = formValues.likes, share = formValues.share, comment = formValues.comment, impression = formValues.impression, reach = formValues.reach;
                        finalViews = typeof views == 'string' ? views.replace(/\./g, '') : parseInt(views).toString();
                        finalLikes = typeof likes == 'string' ? likes.replace(/\./g, '') : parseInt(likes).toString();
                        finalShare = typeof share == 'string' ? share.replace(/\./g, '') : parseInt(share).toString();
                        finalComment = typeof comment == 'string' ? comment.replace(/\./g, '') : parseInt(comment).toString();
                        finalImpression = typeof impression == 'string'
                            ? impression.replace(/\./g, '')
                            : parseInt(impression).toString();
                        finalReach = typeof reach == 'string' ? reach.replace(/\./g, '') : parseInt(reach).toString();
                        formData = {
                            id: insight === null || insight === void 0 ? void 0 : insight.pubId,
                            views: finalViews,
                            likes: finalLikes,
                            share: finalShare,
                            comment: finalComment,
                            impression: finalImpression,
                            reach: finalReach,
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, insightBuktiUpload(__assign({}, formData))];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        error = e_1.response.message;
                        toast.error(error);
                        return [3 /*break*/, 5];
                    case 4:
                        handleClose();
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); },
    });
    return (_jsx(DrawerComponent, __assign({ open: isOpen, size: 'SM', handleClose: handleClose, title: 'Insight' }, { children: _jsxs("form", __assign({ className: 'form w-100', onSubmit: InsightFormik.handleSubmit, noValidate: true, id: 'template-invoice-form' }, { children: [_jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Views', type: 'text', placeholder: 'Views', name: 'views', formik: InsightFormik, formatNumber: true, onfocus: handleFocus }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Likes', type: 'text', placeholder: 'Likes', name: 'likes', formik: InsightFormik, formatNumber: true, onfocus: handleFocus }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Share', type: 'text', placeholder: 'Share', name: 'share', formik: InsightFormik, formatNumber: true, onfocus: handleFocus }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Comments', type: 'text', placeholder: 'Comments', name: 'comment', formik: InsightFormik, formatNumber: true, onfocus: handleFocus }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Impression', type: 'text', placeholder: 'Impression', name: 'impression', formik: InsightFormik, formatNumber: true, onfocus: handleFocus }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Reach', type: 'text', placeholder: 'Reach', name: 'reach', formik: InsightFormik, formatNumber: true, onfocus: handleFocus }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsxs("div", __assign({ style: { textAlign: 'right' } }, { children: [_jsx("button", __assign({ type: 'button', className: 'btn btn-secondary btn-active-light-primary btn-sm', onClick: handleClose, disabled: loading, style: { marginRight: '1rem' } }, { children: _jsx("span", __assign({ className: 'indicator-label' }, { children: "Batal" })) })), _jsxs("button", __assign({ type: 'submit', className: 'btn btn-primary btn-sm', disabled: loading }, { children: [!loading && _jsx("span", __assign({ className: 'indicator-label' }, { children: "Simpan" })), loading && (_jsxs("span", __assign({ className: 'indicator-progress', style: { display: 'block' } }, { children: ["Mohon tunggu...", _jsx("span", { className: 'spinner-border spinner-border-sm align-middle ms-2' })] })))] }))] })) }))] })) })));
};
export default Insight;
